import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import ConfigLoader from './components/ConfigLoader';
import LoadingScreen from './components/LoadingScreen';

const container = document.getElementById('root');
const App = React.lazy(() => import('./App'));

ReactDOM.render(
  <ConfigLoader
    ready={config => (
      <Suspense fallback={<LoadingScreen />}>
        <App config={config} />
      </Suspense>
    )}
  />,
  container
);
